<template>
    <a class="flex-wrap dropdown-item message-dropdown-item"
       :style="{'border-left-color': message.recipientStatus === 10 ? menuColor : 'transparent'}"
       :class="{ 'unread border-left-3': message.recipientStatus === 10, 'border-left-3 border-left-slate-300': message.recipientStatus !== 10 }"
       :href="message._links.self.href"
       @click="$emit('close')">
        <div class="d-flex align-items-center justify-content-between mb-1 w-100">
            <BTooltip v-if="showTooltipSender" placement="left" :target="() => $refs['sender']" :title="sender"/>
            <span ref="sender"
                  @mouseover="showTooltipSender = $event.target.scrollWidth > $event.target.clientWidth"
                  @mouseout="showTooltipSender = false"
                class="message-from w-100 font-size-xs ellipsis-nowrap">{{ sender }}</span>
            <span v-if="message.recipientStatus === 10" class="badge">{{ message.dateString }}</span>
        </div>
        <span v-if="message.topic_id > 0" class="message-title mb-1 text-blue">{{ message.topic.title }}</span>
        <span class="w-100 message body">{{ message.contentCutted }}</span>
    </a>
</template>

<script>

import {mapState} from "vuex";
import {BTooltip} from "bootstrap-vue";

export default {
    name: 'WidgetMessage',
    components: {BTooltip},
    computed: {
        ...mapState({
            menuColor: state => state.navbar.menuColor,
        }),
        sender: vm => `${vm.message.senderName} (${vm.message.senderRoleName})`
    },
    props: {
        message: {
            type: Object,
            default() {
                return {
                    id: 0,
                    topic_id: 0,
                    topic: {
                        title: ''
                    },
                    contentCutted: '',
                    dateString: '',
                    senderName: '',
                    senderRoleName: '',
                    recipientStatus: 10
                }
            },
            required: true
        }
    },
    data() {
        return {
            showTooltipSender: false
        }
    }
}
</script>
